// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__EVF63","box":"styles_box__HHq__","icon":"styles_icon__mWULq"};